export default "__VITE_ASSET__BNLIl1Xv__"